import secureLocalStorage from 'react-secure-storage';
import SecurityUserResponse from '../Models/Authentication/SecurityUserResponse';

const MultiCustomerCheck = (): boolean => {

    const userAuth = secureLocalStorage.getItem('user') as string;
    if (userAuth) {
        if (typeof userAuth === 'string') {
            let securityUserResponse = JSON.parse(userAuth) as SecurityUserResponse;
            return securityUserResponse.isMultiCustomer as boolean;
        }
    }
    return false;
}

export default MultiCustomerCheck;
